import { render } from "./first-comp.vue?vue&type=template&id=6be73178"
import script from "./first-comp.vue?vue&type=script&lang=js"
export * from "./first-comp.vue?vue&type=script&lang=js"

import "./first-comp.vue?vue&type=style&index=0&id=6be73178&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__